import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ConsultsList from 'features/consults/components/ConsultsList/ConsultsList';
import ConsultDetailsWrapper from 'features/consults/components/ConsultDetailsWrapper/ConsultDetailsWrapper';
import { ServiceTypeEnum } from 'utils/enums';

const ClinicConsults = () => (
  <Routes>
    <Route
      path="/"
      element={<ConsultsList consultType={ServiceTypeEnum.CLINIC} />}
    />
    <Route
      path="/:consultId"
      element={<ConsultDetailsWrapper consultType={ServiceTypeEnum.CLINIC} />}
    />
  </Routes>
);

export default ClinicConsults;
